export const FETCH_TARIFFS_REQUEST = 'FETCH_TARIFFS_REQUEST';
export const FETCH_TARIFFS_SUCCESS = 'FETCH_TARIFFS_SUCCESS';
export const FETCH_TARIFFS_FAILURE = 'FETCH_TARIFFS_FAILURE';
